<template>
  <div class="product_list">
    <div class="list_wrap">
      <List
        v-model="loading"
        class="my-box"
        :finished="finished"
        @load="loadMore"
        finished-text="It's the end~"
      >
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="LinkProduct(item.id)"
        >
          <div class="img_div">
            <div class="img-d" v-if="item.view3DUrl">
              <i class="iconfont icon-d"></i>
              <span>3D</span>
            </div>
            <div class="img-v" v-if="item.panoramaUrl">
              <i class="iconfont icon-VR1"></i>
            </div>
            <div
              class="play_video"
              v-if="item.video && JSON.parse(item.video).url"
            >
              <i class="iconfont icon-zhibo"></i>
            </div>
            <template v-if="item.video && JSON.parse(item.video).url">
              <img
                :src="JSON.parse(item.video).cover"
                v-if="JSON.parse(item.video).cover"
                alt
              />
              <img v-else src="@/assets/img/empty.png" />
            </template>
            <template v-else>
              <img
                :src="item.banner"
                v-if="item.banner"
                alt
                v-load="'oProSmall'"
              />
              <img v-else src="@/assets/img/empty.png" />
            </template>
          </div>
          <div class="pro_info">
            <div class="pro_title">
              <p class="van-ellipsis">{{ item.name}}</p>
              <!-- <div class="is_live" v-if="item.exhibitor.isLiving">
                <span></span>
                直播中
              </div> -->
              <div class="is_live is_hot" v-if="item.isPopularize">
                <i class="icon iconfont icon-huo"></i>
                hot
              </div>
            </div>
            <p class="van-ellipsis comp_name">
              {{ item.exhibitor.company.nameEn}}
            </p>
            <p v-if="item.selling" class="van-multi-ellipsis--l2 selling">
              {{ item.selling}}
            </p>
            <!-- <div class="eval" v-if="item.newestEvaluates&&item.newestEvaluates.length">
              <span>最新评价：</span>{{item.newestEvaluates[0].content}}
            </div>
            <div class="likes_div" v-if="item.likes&&item.likes.length">
              <div class="avatar_img">
                <div v-for="(avaItem,i) in item.likes" :key="i">
                  <img v-if="avaItem.userInfo.avatarUrl" :src="avaItem.userInfo.avatarUrl" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
              </div>
              <p :class="'ava_count'+item.likes.length">共{{item.likeCount}}人点赞推荐</p>
            </div> -->
          </div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
    <inquiry ref="inquiry"></inquiry>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
import inquiry from "@/components/inquiry/index";
export default {
  name: "product-list",
  data() {
    return {
      loading: false, //展品加载状态
      finished: false, //展品是否完成状态
      list: [], //展品列表
      pageIndex: 0,
      pageSize: 20,
      queryProductFollow: {},
    };
  },
  components: { List, inquiry },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      LinkProduct: "linkTo/LinkProduct",
    }),
    //打开询盘 点击索取样品
    openInquiry(item) {
      console.log(item);
      this.$store.commit("company/setExhibitorId", item.exhibitorId);
      this.$store.commit("company/setCompanyId", item.exhibitor.company.id);
      let exInfo = {
        compLogo: item.exhibitor.company.logo,
        compName: item.exhibitor.company.name,
        boothInfo: item.exhibitor.boothInfo,
      };
      this.$refs.inquiry.open(exInfo);
    },
    getList() {
      let query = gql`
        query queryProductFollow($query: QueryInput!) {
          queryProductFollow(query: $query) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items {
              exhibitorId
              id
              productId
              product {
                id
                name
                nameEn
                category
                banner
                view3DUrl
                panoramaUrl
                isPopularize
                exhibitor {
                  businesses(num: 3) {
                    isSample
                    remark
                  }
                  isLiving
                  boothInfo
                  company {
                    id
                    name
                    nameEn
                    logo
                  }
                }
                likes {
                  userInfo
                }
                likeCount
                selling
                sellingEn
                newestEvaluates {
                  content
                }
                video
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "userId",
          v: this.userInfo.userId,
        },
        EqualB: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      };
      let order = [
        {
          N: "createAt",
          v: 0,
        },
      ];
      let opt = {
        page: this.pageIndex,
        size: this.pageSize,
        where: JSON.stringify(where),
        order: JSON.stringify(order),
      };
      this.$apollo.addSmartQuery("queryProductFollow", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "no-cache", //清理缓存
        result(data) {
          let res = JSON.parse(JSON.stringify(data.data.queryProductFollow));
          // let res=data.data.queryProduct;
          console.log("关注展品", res);
          let items = [];
          if (res && res.items.length) {
            res.items.forEach((el) => {
              items.push(el.product);
            });
          }
          if (items.length) {
            items.forEach((e) => {
              if (e.category && e.category.indexOf("{") != -1) {
                let cate = JSON.parse(e.category);
                e.category = cate.Value;
              }
              if (e.banner && e.banner.indexOf("[") != -1) {
                let arr = JSON.parse(e.banner);
                e.banner = arr[0];
              }
              if (e.likes && e.likes.length) {
                e.likes.forEach((el) => {
                  el.userInfo = JSON.parse(el.userInfo);
                });
              }
            });
          }
          if (this.pageIndex == 1) {
            this.list = items;
          } else {
            this.list = [...new Set([...this.list, ...items])];
          }
          this.loading = false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err) {
          this.loading = false;
          this.finished = true;
          console.log("err", err);
        },
      });
      // setTimeout(()=>{
      //   this.list=[...this.list,...this.list];
      //   this.loading=false;
      //   if(this.list.length>20){
      //     this.finished=true
      //   }
      // },1000)
    },
    loadMore() {
      if (this.finished) return;
      this.pageIndex += 1;
      this.getList();
    },
    //打招呼
    goCall(item) {},
  },
};
</script>

<style scoped lang="scss">
.product_list {
  .list_wrap {
    .item {
      background: #fff;
      position: relative;
      padding: 0.3rem 0;
      border-bottom: solid 1px #dce4ec;
      display: flex;
      &:first-child {
        padding-top: 0;
      }
      .img_div {
        width: 1.6rem;
        height: 1.6rem;
        margin-right: 0.2rem;
        display: block;
        flex-shrink: 0;
        // border: solid 1px #dce4ec;
        position: relative;
        .play_video {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 0.72rem;
            color: #fff;
          }
        }
        img {
          width: 100%;
          height: 100%;
        }
        .img-d {
          width: 0.6rem;
          height: 0.26rem;
          background-color: #fff;
          border-radius: 0px 0px 0px 0.1rem;
          border: solid 1px #ff5c00;
          color: #ff5c00;
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          align-items: center;
          span {
            font-size: 0.16rem;
          }
        }
        .img-v {
          width: 0.38rem;
          background-color: #fff;
          border: solid 1px #0190fe;
          color: #0190fe;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 0.16rem;
          }
        }
      }
      .pro_info {
        max-width: calc(100% - 1.8rem);
        .pro_title {
          display: flex;
          margin-top: -0.05rem;
          align-items: center;
          p {
            font-size: 0.26rem;
            color: #333;
            font-weight: bold;
            min-height: 0.3rem;
          }
          .is_live {
            width: 0.88rem;
            height: 0.3rem;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            color: #fff;
            margin-left: 0.15rem;
            background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
              linear-gradient(#000, #000);
            background-blend-mode: normal, normal;
            border-radius: 0.05rem;
            color: #fff;
            font-size: 0.18rem;
            // vertical-align: middle;
            span {
              display: block;
              height: 0.12rem;
              width: 0.12rem;
              margin-right: 0.06rem;
              border-radius: 50%;
              background: #fff;
            }
          }
          .is_hot {
            background: #ff5c00;
          }
        }
        .comp_name {
          font-size: 0.22rem;
          color: #333;
          margin-top: 0.08rem;
          min-height: 0.24rem;
        }
        .selling {
          margin-top: 0.1rem;
          font-size: 0.2rem;
          color: #999;
        }
        .bus {
          display: flex;
          align-items: center;
          margin-right: 0.2rem;
          margin-top: 0.14rem;
          height: 0.36rem;
          border-radius: 0.05rem;
          color: #666;
          p {
            font-size: 0.2rem;
            padding: 0 0.1rem;
            background: #eef8ff;
            &.is_sa {
              padding-right: 0;
            }
          }
          span {
            padding-right: 0.1rem;
            flex-shrink: 0;
            padding-left: 0.2rem;
            background: #eef8ff;
            color: #199bff;
            text-decoration: underline;
            font-size: 0.2rem;
          }
        }
        .eval {
          margin-top: 0.14rem;
          padding: 0.08rem 0.1rem;
          background: #f2f2f2;
          color: #666;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 0.2rem;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          span {
            font-size: 0.2rem;
            color: #999;
          }
        }
        .likes_div {
          display: flex;
          margin-top: 0.24rem;
          align-items: center;
          .avatar_img {
            flex-shrink: 0;
            display: flex;
            div {
              width: 0.31rem;
              height: 0.31rem;
              position: relative;
              left: -0.15rem;
              z-index: 1;
              &:nth-child(1) {
                left: 0;
                z-index: 3;
              }
              &:nth-child(2) {
                z-index: 2;
              }
              &:nth-child(3) {
                left: -0.3rem;
              }
              img {
                display: block;
                border: 1px solid #fff;
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }
          p {
            font-size: 0.2rem;
            color: #999;
            &.ava_count3 {
              margin-left: -0.2rem;
            }
            &.ava_count2 {
              margin-left: -0.05rem;
            }
            &.ava_count1 {
              margin-left: 0.1rem;
            }
          }
        }
      }
    }
  }
  &::v-deep {
    .van-list__finished-text,
    .van-list__loading {
      width: 100%;
    }
  }
}
.f-tac {
  text-align: center;
  width: 100%;
  flex-shrink: 0;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
